import React, { useMemo } from 'react'

import { useLocalization } from '../../../app/_providers/LocalizationProvider.client'
import { usePortal } from '../../../app/_providers/PortalProvider.client'
import { useFixturesContext } from '../../../brunswick/containers/fixtures'

import { Template } from './Template'
import { useViewModel } from './useViewModel'

const PromoBar = (props: Parameters<typeof useViewModel>[0]) => {
  const viewModel = useViewModel(props)
  return <Template {...viewModel} />
}

/**
 * @deprecated Old pages directory promobar. We are migrating to the app directory.
 */
export const PromoBarFromContext: React.FC = () => {
  const { promoBar: defaultPromoBar, regionData } = useFixturesContext()
  const { region: currentRegion } = useLocalization()
  const { portal } = usePortal()

  const regionalPromoBar = useMemo(() => {
    return regionData?.regions.find(contentfulRegion => contentfulRegion.id === currentRegion.id)
      ?.promoBarRegion
  }, [currentRegion.id, regionData?.regions])

  const promoBar = regionalPromoBar ?? defaultPromoBar

  if (!promoBar) return null

  return (
    <PromoBar
      {...promoBar}
      pages={
        portal?.promoBarPages && portal.promoBarPages.length > 0
          ? portal.promoBarPages
          : promoBar.pages
      }
    />
  )
}
